import React, { useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Typography,
  CircularProgress,
  IconButton,
  Box,
} from "@mui/material";
import { IoClose } from "react-icons/io5";

export default function EditDetails({
  open,
  onClose,
  setToggleDetails,
  currentUser,
  isAuthenticated,
}) {
  const [isError, setIsError] = useState("");
  const [msg, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const rfName = useRef();
  const rfPhone = useRef();

  const handleClose = () => {
    if (onClose) onClose();
    if (setToggleDetails) setToggleDetails(false);
  };

  const editDetails = () => {
    if (!isAuthenticated || !currentUser) return;
    const name = rfName.current?.value?.trim() ?? "";
    const phone = (rfPhone.current?.value ?? "").trim();

    if (phone.length < 10) {
      setIsError("Phone number must be at least 10 digits");
      return;
    }
    if (!name.includes(" ")) {
      setIsError("Enter a valid name including Surname and Firstname");
      return;
    }
    if (name.length < 3) {
      setIsError("Name too short");
      return;
    }

    setIsError("");
    setIsLoading(true);
    fetch(`/api/auth/${currentUser.UserID}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ Name: name, Phone: phone }),
    })
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((data) => {
        setIsLoading(false);
        if (data.success) {
          setMessage(data.success);
          setTimeout(() => handleClose(), 1500);
        } else setIsError(data.error || "Update failed");
      })
      .catch(() => {
        setIsLoading(false);
        setIsError("Update failed!");
      });
  };

  if (!currentUser) return null;

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Edit Account Details for {currentUser.Name}
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
          size="small"
        >
          <IoClose size={24} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {msg && (
          <Typography color="primary" sx={{ mb: 2 }}>
            {msg}
          </Typography>
        )}
        {isError && (
          <Typography color="error" sx={{ mb: 2 }}>
            {isError}
          </Typography>
        )}
        <Box
          component="form"
          onSubmit={(e) => e.preventDefault()}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <TextField
            inputRef={rfName}
            label="Name"
            variant="outlined"
            margin="normal"
            defaultValue={currentUser.Name}
            fullWidth
          />
          <TextField
            inputRef={rfPhone}
            label="Phone Number"
            variant="outlined"
            margin="normal"
            defaultValue={currentUser.Phone}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={editDetails}
            sx={{ mt: 2 }}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : "Submit"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
